import { z } from 'zod';
import { ageSchema, entityIdSchema, localizedTextSchema, uniqueArraySchema } from './common';
import { ageRangeRule, publishStateSchema } from './content';

/**
 * A mission links editorial content to an interactive activity via a versioned game manifest and
 * learning-objective identifiers (e.g. `circuits.closed-loop`). Content items reference missions
 * through `missionId`; a mission may be linked from several items.
 */

export const objectiveIdSchema = z
  .string()
  .max(80)
  .regex(
    /^[a-z0-9-]+(\.[a-z0-9-]+)+$/,
    'Expected a dotted objective id, e.g. circuits.closed-loop',
  );

export const missionFieldsSchema = z.strictObject({
  id: entityIdSchema,
  gameManifestId: entityIdSchema,
  manifestSchemaVersion: z.int().min(1),
  objectiveIds: uniqueArraySchema(objectiveIdSchema).min(1).max(20),
  ageMin: ageSchema,
  ageMax: ageSchema,
  title: localizedTextSchema(120),
  instructions: localizedTextSchema(1000),
  publishState: publishStateSchema,
  /** Optimistic concurrency for the editorial API (migration 0004). */
  version: z.int().min(1),
});

export const missionSchema = missionFieldsSchema.refine(...ageRangeRule);
export type Mission = z.infer<typeof missionSchema>;
